'use client';

import { Box } from '@doist/marketist';
import cn from 'clsx';
import { useCloudinaryImageLocal } from 'services/hooks/use-cloudinary-local';
import css from './reviews-grid.module.css';
import type { ReactNode } from 'react';
type GridProps = {
  backgroundImage: string;
  children: ReactNode;
};
export function ReviewsGrid({
  backgroundImage,
  children
}: GridProps) {
  const bgImage = useCloudinaryImageLocal(backgroundImage);
  return <Box className={cn(css.wrapper, 'mbe-96 md-mbe-128')} data-sentry-element="Box" data-sentry-component="ReviewsGrid" data-sentry-source-file="reviews-grid.tsx">
            <Box className={css.reviewsGridSection} style={{
      backgroundImage: `url(${bgImage})`
    }} data-sentry-element="Box" data-sentry-source-file="reviews-grid.tsx">
                <Box className={css.reviewsGrid} data-sentry-element="Box" data-sentry-source-file="reviews-grid.tsx">{children}</Box>
            </Box>
        </Box>;
}
ReviewsGrid.Column = function Column({
  children
}: {
  children: React.ReactNode;
}) {
  return <Box className={css.column}>{children}</Box>;
};